import axios from "axios";

export default {
    getClientSettings: async (clientId, featureId) => {
        const { data } = await axios.get(`/clients/${clientId}/client_settings/${featureId}`)
        return data
    },
    saveClientSettings: async (clientId, featureId, payload) => {
        const { data } = await axios.post(`/clients/${clientId}/client_settings/${featureId}`, payload)

        return data
    },
    deleteClientSettings: async (clientId, featureId) => {
        const { data } = await axios.delete(`/clients/${clientId}/client_settings/${featureId}`)
        return data
    },
    testClientSettings: async (clientId, featureId, payload) => {
        const { data } = await axios.post(`/clients/${clientId}/test_client_settings/${featureId}`, payload)
        return data
    }
}